export default __webpack_public_path__ + "static/simple-histogram-8f1ac89e0a2736d82f88bb55b92ac237.png";